import React from "react";
import {adds} from "../../content/food";

const Adds = ({onglet}) => {


    return <div className={onglet === 3 ? "visible" : "hidden"}>
        <div className="mx-5 my-14">
            {adds?.map(add =>
                <div key={add.id} className="mb-2 grid grid-cols-5 md:mx-60 md:text-lg"><p className="col-span-4">{add.name}</p><p
                    className=" text-center">{add.price}€</p>
                </div>) }
        </div>
    </div>;
};

export default Adds;